var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagHongKong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_7664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.75 75C58.4607 75 75.25 58.2107 75.25 37.5C75.25 16.7893 58.4607 0 37.75 0C17.0393 0 0.25 16.7893 0.25 37.5C0.25 58.2107 17.0393 75 37.75 75Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6218 28.3693C40.7695 31.9141 39.2553 31.238 38.5122 34.3295C34.1348 33.277 31.4389 28.8751 32.4914 24.4974C33.5434 20.12 37.9457 17.4241 42.3233 18.4766C40.8369 24.6593 42.3842 25.1989 41.6218 28.3693Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2628 30.996C33.3708 32.9018 32.2599 34.1333 34.9701 35.7954C32.6164 39.6335 27.5971 40.8368 23.7589 38.4833C19.9209 36.1297 18.7172 31.1101 21.0709 27.2721C26.4918 30.5961 27.4827 29.2914 30.2628 30.996Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2509 42.611C32.024 40.2441 32.8515 41.6812 35.2698 39.6172C38.1929 43.0416 37.7862 48.1873 34.362 51.1104C30.9375 54.0335 25.7918 53.6264 22.8691 50.2023C27.7052 46.0739 26.7705 44.7279 29.2509 42.611Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9848 47.1628C38.5903 43.7941 40.2127 43.4508 38.9971 40.5133C43.1571 38.7917 47.9254 40.7683 49.6472 44.9283C51.3688 49.0884 49.3919 53.8566 45.2319 55.5783C42.8007 49.703 41.232 50.176 39.9848 47.1628Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6304 38.3607C43.9957 38.6459 44.1701 36.9965 41.0009 37.2453C40.6489 32.7571 44.0026 28.8327 48.491 28.4804C52.9793 28.1289 56.9036 31.4823 57.2554 35.9708C50.916 36.4679 50.881 38.106 47.6304 38.3607Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_7664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagHongKong);
export default __webpack_public_path__ + "static/media/flagHongKong.b965ed917865bff8245e9755acbda914.svg";
export { ForwardRef as ReactComponent };